// extracted by mini-css-extract-plugin
export var copyableField = "_mn-4";
export var customerBadge = "_mn-0";
export var customerInfoTitle = "_mn-2";
export var details = "_mn-1";
export var dropdownContainer = "_mn-5";
export var dropdownImage = "_mn-6";
export var editAssigneeForm = "_mn-a";
export var editButton = "_mn-3";
export var email = "_mn-7";
export var hidden = "_mn-d";
export var input = "_mn-8";
export var saveButton = "_mn-b";
export var shopifyIcon = "_mn-c";
export var suggestionBadge = "_mn-e";
export var suggestionText = "_mn-f";
export var username = "_mn-9";